import { render, staticRenderFns } from "./HtTabsColumn.vue?vue&type=template&id=f66d9188&scoped=true&"
import script from "./HtTabsColumn.vue?vue&type=script&lang=js&"
export * from "./HtTabsColumn.vue?vue&type=script&lang=js&"
import style0 from "./HtTabsColumn.vue?vue&type=style&index=0&id=f66d9188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66d9188",
  null
  
)

export default component.exports